<template>
    <div class="redpacket-container-packet">
        <div v-if="redpacketStyle" class="redpacket-container-packet-main">
            <redpacket-main :redpacket-style="redpacketStyle" :send-redpack="props.tpl.props.sendRedpack" />
            <div class="redpacket-container-packet-main-content">
                <flow-container :children="tpl.children"></flow-container>
            </div>
        </div>
        <flow-container v-else :children="tpl.children"></flow-container>
    </div>
</template>



<script >
import RedpacketMain from '../components/Main/index.vue';
const {
  plugins: {
    ComplexComp
  }
} = require('@futuweb/fego-render');
const FlowContainer = ComplexComp.Container.Flow;
const __sfc_main = {
  components: {
    FlowContainer,
    RedpacketMain
  }
};
__sfc_main.props = ['tpl', 'redpacketStyle'];
__sfc_main.setup = (__props, __ctx) => {
  const {
    defineExpose,
    defineProps
  } = require('vue-demi');
  const props = __props;
  return Object.assign({
    props
  }, {
    openRedpacket: () => {
      props.tpl.props.sendRedpack && props.tpl.props.sendRedpack();
    }
  });
};
__sfc_main.components = Object.assign({
  RedpacketMain,
  FlowContainer
}, __sfc_main.components);
export default __sfc_main;
</script>

<style lang="less" scoped>
.redpacket-container-packet {
    min-height: 20px;
    height: auto !important;

    &-main {
        position: relative;
        z-index: 2;

        &-content {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 3;
        }
    }
}
</style>
